import { Box } from '@mui/material';
import React, { useRef } from 'react';
import type { MultiSelectChipsProps } from '../types';
import { MultiSelectChipsOverflowList } from './components/MultiSelectChipsOverflowList';
import { MultiSelectChipsVisibleList } from './components/MultiSelectChipsVisibleList';
import { useMultiSelectChipsOverflow } from './hooks/useMultiSelectChipsOverflow';
import { getContainerSx } from './utils';

export function MultiSelectChips({
    selectedValues,
    getTagProps,
    onRemove,
    readOnly = false,
    allValuesVisible = true,
    stopOverflowPropagation = false,
    'data-testid': dataTestId
}: MultiSelectChipsProps) {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const { visibleCount, overflow } = useMultiSelectChipsOverflow({
        allValuesVisible,
        selectedValues,
        containerRef
    });
    const containerSx = getContainerSx(allValuesVisible);
    const showOverflowList = !allValuesVisible;
    const hasSelectedValues = selectedValues.length > 0;

    if (!hasSelectedValues) {
        return null;
    }

    return (
        <Box ref={containerRef} data-testid={dataTestId} sx={containerSx}>
            <MultiSelectChipsVisibleList
                selectedValues={selectedValues}
                visibleCount={visibleCount}
                allValuesVisible={allValuesVisible}
                getTagProps={getTagProps}
                onRemove={onRemove}
                readOnly={readOnly}
            />
            {showOverflowList && (
                <MultiSelectChipsOverflowList
                    overflow={overflow}
                    onRemove={onRemove}
                    readOnly={readOnly}
                    stopOverflowPropagation={stopOverflowPropagation}
                />
            )}
        </Box>
    );
}
